import { imbalanceColorStore } from "./imbalanceColorStore";

export function getImbalanceStyleColor(key: string, value: any): string {
  const config = imbalanceColorStore.get();
  const colorSet = config[key];

  if (value == null || typeof value !== 'number' || isNaN(value) || value === undefined) {
    return '#eff0f1';
  }

  if (!colorSet || !colorSet.color1 || !colorSet.color2 || !colorSet.color3) {
    console.warn(`Цветовая схема для "${key}" не найдена или неполная`);
    return '#eff0f1';
  }

  const absValue = Math.abs(value);
  const absSep1 = Math.abs(colorSet.sep1);
  const absSep2 = Math.abs(colorSet.sep2);

  if (absValue < absSep1) {
    return colorSet.color1;
  } else if (absValue >= absSep1 && absValue < absSep2) {
    return colorSet.color2;
  } else {
    return colorSet.color3;
  }
}
